import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  CLEAR_LOGIN_ERROR,
  REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILED,
  UPDATE_USER_WALLET_HISTORY,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, update, set, off, child, push, get } from "firebase/database";
import { onAuthStateChanged, signInWithCredential, signInWithPopup, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithCustomToken } from "firebase/auth";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { callFunction, errorMessage } from '../other/apiClient';

let profileUnsubscribe = null;
let authUnsubscribe = null;

// À appeler avant de supprimer son propre profil, pour ne pas le recréer automatiquement.
export const detachProfileListener = () => {
  if (profileUnsubscribe) {
    profileUnsubscribe();
    profileUnsubscribe = null;
  }
};

const buildProfileFromAuthUser = (user) => {
  const data = { uid: user.uid, mobile: user.phoneNumber || '', email: user.email || '', firstName: '', lastName: '', verifyId: '' };
  const provider = user.providerData && user.providerData[0];
  if (provider) {
    if (provider.email) data.email = provider.email;
    if (provider.phoneNumber) data.mobile = provider.phoneNumber;
    if (provider.displayName) {
      const parts = provider.displayName.trim().split(/\s+/);
      data.firstName = parts[0] || '';
      data.lastName = parts.slice(1).join(' ');
    }
    if (provider.photoURL) data.profile_image = provider.photoURL;
  }
  if (!data.firstName && user.displayName) {
    const parts = user.displayName.trim().split(/\s+/);
    data.firstName = parts[0] || '';
    data.lastName = parts.slice(1).join(' ');
  }
  return data;
};

export const fetchUser = () => (dispatch) => {
  const { auth, singleUserRef } = firebase;
  const lang = () => store.getState().languagedata.defaultLanguage;

  dispatch({ type: FETCH_USER, payload: null });

  if (authUnsubscribe) authUnsubscribe();
  authUnsubscribe = onAuthStateChanged(auth, (user) => {
    // Un seul listener de profil à la fois : évite les doublons à chaque reconnexion.
    if (profileUnsubscribe) {
      profileUnsubscribe();
      profileUnsubscribe = null;
    }
    if (!user) {
      dispatch({ type: FETCH_USER_FAILED, payload: { code: lang().auth_error, message: lang().not_logged_in } });
      return;
    }
    let creatingProfile = false;
    profileUnsubscribe = onValue(singleUserRef(user.uid), async (snapshot) => {
      if (snapshot.val()) {
        dispatch({ type: FETCH_USER_SUCCESS, payload: { ...snapshot.val(), uid: user.uid } });
        return;
      }
      // Premier passage d'un compte Google/Apple : le serveur crée le profil, puis ce listener se redéclenche.
      if (creatingProfile) return;
      creatingProfile = true;
      const json = await callFunction('check_auth_exists', { data: JSON.stringify(buildProfileFromAuthUser(user)) }, { basicAuth: true });
      creatingProfile = false;
      if (json.uid) {
        dispatch({ type: FETCH_USER_SUCCESS, payload: json });
      } else {
        dispatch({ type: FETCH_USER_FAILED, payload: { code: lang().auth_error, message: errorMessage(json) } });
      }
    }, (error) => {
      dispatch({ type: FETCH_USER_FAILED, payload: { code: lang().auth_error, message: errorMessage(error) } });
    });
  });
};

export const validateReferer = async (referralId) => {
  return callFunction('validate_referrer', { referralId }, { auth: false });
};

// Renvoie { users, emailExists, mobileExists } ou { error }.
export const checkUserExists = async (data) => {
  return callFunction('check_user_exists', { email: data.email, mobile: data.mobile }, { basicAuth: true, auth: false });
};

// Renvoie { uid } ou { error, code } avec un message affichable tel quel.
export const mainSignUp = async (regData) => {
  return callFunction('user_signup', { regData }, { auth: false });
};

export const updateProfileWithEmail = (profileData) => async () => {
  const result = await callFunction('update_user_email', profileData, { basicAuth: true });
  if (result.error) {
    return { success: false, error: result.error };
  }
  return { success: true };
};


export const requestPhoneOtpDevice = (verificationId) => async (dispatch) => {
    dispatch({
      type: REQUEST_OTP_SUCCESS,
      payload: verificationId
    }); 
}

export const mobileSignIn = (verficationId, code) => (dispatch) => {
  const {
    auth,
    mobileAuthCredential,
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  signInWithCredential(auth, mobileAuthCredential(verficationId, code))
    .then((user) => {
      //OnAuthStateChange takes care of Navigation
    }).catch(error => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
    });
};

export const saveAddresses = async (uid, location, name) => {
  const { singleUserRef } = firebase;
  onValue(child(singleUserRef(uid), "savedAddresses"), (savedAdd) => {
    if (savedAdd.val()) {
      let addresses = savedAdd.val();
      let didNotMatch = true;
      for (let key in addresses) {
        let entry = addresses[key];
        if (entry.name == name ) {
          didNotMatch = false;
          update(child(singleUserRef(uid),"savedAddresses/" + key),{
            description: location.add,
            lat: location.lat,
            lng: location.lng,
            count: 1,
            name: name
          });
          break;
        }
      }
      if (didNotMatch) {
        push(child(singleUserRef(uid),"savedAddresses"),{
          description: location.add,
          lat: location.lat,
          lng: location.lng,
          count: 1,
          name: name
        });
      }
    } else {
      push(child(singleUserRef(uid),"savedAddresses"),{
        description: location.add,
        lat: location.lat,
        lng: location.lng,
        count: 1,
        name: name
      });
    }
  }, {onlyOnce: true});
};

export const googleLogin = (idToken, accessToken) => (dispatch) => {

  const {
    auth,
    googleCredential
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  const credential = googleCredential(idToken, accessToken);
  signInWithCredential(auth, credential)
    .then((user) => {
      //OnAuthStateChange takes care of Navigation
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
    });
}

export const appleSignIn = (credentialData) => (dispatch) => {

  const {
    auth,
    appleProvider
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (credentialData) {
    const credential = appleProvider.credential(credentialData);
    signInWithCredential(auth, credential)
      .then((user) => {
        //OnAuthStateChange takes care of Navigation
      })
      .catch((error) => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
      });
  } else {
    signInWithPopup(auth, appleProvider).then(function (result) {
      signInWithCredential(auth, result.credential)
        .then((user) => {
        //OnAuthStateChange takes care of Navigation
        })
        .catch(error => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
        }
        );
    }).catch(function (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
    });
  }
};

export const signOff = () => async (dispatch) => {
  const { auth, singleUserRef, walletHistoryRef, userNotificationsRef } = firebase;
  const uid = auth.currentUser ? auth.currentUser.uid : null;

  if (profileUnsubscribe) {
    profileUnsubscribe();
    profileUnsubscribe = null;
  }
  if (uid) {
    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
    // Écriture envoyée sans attendre : hors ligne, la déconnexion ne doit jamais bloquer.
    // On laisse 2,5 s à l'écriture (encore authentifiée) pour arriver, sans jamais bloquer hors ligne.
    const profile = store.getState().auth.profile;
    const payload = profile && profile.usertype === 'driver' ? { driverActiveStatus: false, pushToken: null } : { pushToken: null };
    await Promise.race([
      update(singleUserRef(uid), payload).catch(() => null),
      new Promise((resolve) => setTimeout(resolve, 2500)),
    ]);
  }
  try {
    await signOut(auth);
  } catch (e) {
    console.warn('signOut failed', e);
  }
  dispatch({ type: USER_SIGN_OUT, payload: null });
};

export const updateProfile = (updateData) => async (dispatch) => {

  const {
    auth,
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef
  } = firebase;

  const uid = auth.currentUser.uid;
  
  if (updateData.licenseImage) {
    await uploadBytesResumable(driverDocsRef(uid), updateData.licenseImage);
    updateData.licenseImage = await getDownloadURL(driverDocsRef(uid));
  }
  if (updateData.licenseImageBack) {
    await uploadBytesResumable(driverDocsRefBack(uid),updateData.licenseImageBack);
    updateData.licenseImageBack = await getDownloadURL(driverDocsRefBack(uid));
  }
  if (updateData.verifyIdImage) {
    await uploadBytesResumable(verifyIdImageRef(uid), updateData.verifyIdImage);
    updateData.verifyIdImage = await getDownloadURL(verifyIdImageRef(uid));
  }

  // Firebase RTDB refuse les valeurs undefined dans update()
  const payload = Object.fromEntries(Object.entries(updateData).filter(([_, v]) => v !== undefined));
  if (Object.keys(payload).length > 0) {
    await update(singleUserRef(uid), payload);
  }
  return { success: true };
};


export const updateProfileImage = (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  return uploadBytesResumable( profileImageRef(uid), imageBlob).then(() => {
    if (imageBlob && typeof imageBlob.close === 'function') imageBlob.close();
    return getDownloadURL(profileImageRef(uid))
  }).then((url) => {
    update(singleUserRef(uid), {
      profile_image: url
    });
  })
};

export const updateWebProfileImage = async (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = auth.currentUser.uid;

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};
export const updateCustomerProfileImage = async (imageBlob, id) => {

  const {
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = id

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};

export const updatePushToken = (token, platform)  => {

  const {
    auth,
    singleUserRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  update(singleUserRef(uid), {
    pushToken: token,
    userPlatform: platform
  });
};

export const clearLoginError = () => (dispatch) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const fetchWalletHistory = () => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = auth.currentUser.uid;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }
  });
};
export const fetchUserWalletHistory = (userId) => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = userId;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }else{
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload:[]
      });
    }
  });
};

export const sendResetMail = (email) => async (dispatch) => {
  const { authRef } = firebase;
  dispatch({ type: SEND_RESET_EMAIL, payload: email });
  try {
    await sendPasswordResetEmail(authRef(), (email || '').trim());
  } catch (error) {
    // Ne pas révéler si l'adresse existe : seul un format invalide est signalé.
    if (error && error.code === 'auth/invalid-email') {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: { code: store.getState().languagedata.defaultLanguage.auth_error, message: errorMessage(error) }
      });
    }
  }
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
  const {
    authRef
  } = firebase;

  dispatch({ type: USER_SIGN_IN, payload: null });
  signInWithEmailAndPassword(authRef(), (email || '').trim(), pass)
    .then((user) => {
      //OnAuthStateChange takes care of Navigation
    })
    .catch((error) => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: error && error.code, message: errorMessage(error) }
      });
    });
}

// Connexion par SMS désactivée : conservé pour compatibilité des écrans existants.
export const requestMobileOtp = () => async (dispatch) => {
  dispatch({ type: REQUEST_OTP_FAILED, payload: "La connexion par SMS n'est plus disponible. Utilisez votre e-mail, Google ou Apple." });
};

export const verifyMobileOtp = () => async (dispatch) => {
  dispatch({ type: USER_SIGN_IN_FAILED, payload: { message: "La connexion par SMS n'est plus disponible. Utilisez votre e-mail, Google ou Apple." } });
};

export const updateAuthMobile = async (mobile, otp) => {
  const result = await callFunction('update_auth_mobile', { mobile, otp });
  if (result.success) {
    return { success: true };
  }
  return { success: false, error: result.error };

}
